import script from "./AssigneeCircles.vue?vue&type=script&setup=true&lang=js"
export * from "./AssigneeCircles.vue?vue&type=script&setup=true&lang=js"

import "./AssigneeCircles.vue?vue&type=style&index=0&id=bf7a4092&scoped=true&lang=css"

import exportComponent from "/builds/sense/sense-signer/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf7a4092"]])

export default __exports__